export const SET_LATEST_TERMS_OF_USE = (state, payload) =>
  (state.latest_terms_of_use = payload);

// export const SET_LATEST_TERMS_OF_USE_TO_ACCEPT = (state, payload) =>
//   (state.latest_terms_of_use_to_accept = payload);
